import Req from '../../req'
import md5 from 'js-md5';
const actions = {
    getGoodsList: function (store, [category, cb]) {
        let data = {
            category: category
        }
        Req.mall.goods.list(data, cb);
    },
    todayList: function (store, [cb]) {
        let data = {};
        Req.mall.hot.today(data, cb);
    },
    threeDaysList: function (store, [cb]) {
        let data = {};
        Req.mall.hot.threeDays(data, cb);
    },
    getExchangeList: function (store, [data, cb]) {
        data.owcode = store.rootState.user.owcode;
        store.dispatch("getSign", [data, function (err, sign) {
            data.sign = sign;
            Req.mall.exchange.list(data, cb);
        }])
    },
    getUserInfo: function (store, [data, cb]) {
        data.owcode = store.rootState.user.owcode;
        store.dispatch("getSign", [data, function (err, sign) {
            data.sign = sign;

            Req.mall.user.info(data, function (err, data) {
                store.rootState.user.all_points = data.data.total_points;
                store.rootState.user.left_points = data.data.left_points;
                cb ? cb(err, data) : null;
            });
        }])
    },
    getKdtsInfo: function (store, [cb]) {
        let data = {
            type: 2,
            uid: store.rootState.user.uid
        }
        Req.mall.kdts.query(data, cb)
    },
    getUserPoints: function (store, [data, cb]) {
        data.owcode = store.rootState.user.owcode;
        store.dispatch("getSign", [data, function (err, sign) {
            data.sign = sign;
            Req.mall.user.points(data, cb);
        }])
    },
    fuluOrder: function (store, [data, cb]) {
        store.dispatch("getSign", [data, function (err, sign) {
            data.sign = sign;
            Req.mall.fulu.order(data, cb);
        }])
    },
    fuluQuery: function (store, [data, cb]) {
        store.dispatch("getSign", [data, function (err, sign) {
            data.sign = sign;
            Req.mall.fulu.query(data, cb);
        }])
    },
    getSign: function (store, [data, cb]) {
        let res = Object.keys(data).sort();
        let string = ""
        for (let key in res) {
            // console.log("key: " + res[key] + " ,value: " + data[res[key]]);
            let newKey = res[key];
            let value = data[res[key]];
            if (string != "") {
                string += ("&" + newKey + "=" + value);
            } else {
                string += (newKey + "=" + value);
            }
        }
        string += ("&key=" + store.rootState.user.rkey);
        // console.log(string);
        cb ? cb(null, md5(string)) : null;
    },
    exchangeGoods: function (store, [data, cb]) {
        data.owcode = store.rootState.user.owcode;
        store.dispatch("getSign", [
            data,
            function (err, sign) {
                data.sign = sign;
                Req.mall.goods.exchange(data, cb);
            },
        ]);
    },
}
export default {
    namespaced: false,
    actions
}